import { render, staticRenderFns } from "./safe-rescureddetail.vue?vue&type=template&id=7f3d8532&scoped=true&"
import script from "./safe-rescureddetail.vue?vue&type=script&lang=js&"
export * from "./safe-rescureddetail.vue?vue&type=script&lang=js&"
import style0 from "./safe-rescureddetail.vue?vue&type=style&index=0&id=7f3d8532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3d8532",
  null
  
)

export default component.exports